// eslint-disable-next-line
import React, { Fragment } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { CiWarning } from "react-icons/ci";
import "./login.css";

const UsageGuidelinesModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <Fragment>
            <div className="guidelines-overlay">
                <div className="guidelines-modal animate-in">
                    <header className="guidelines-header">
                        <div className="logo-brand">
                            <FaWhatsapp className="brand-icon" />
                            <h2>WhatsApp Usage Guidelines</h2>
                        </div>
                    </header>

                    <main className="guidelines-body">
                        <p className="guidelines-intro">
                            ⚠️ Please read these recommendations carefully before using your WhatsApp integration. 
                            This setup relies on a sensitive connection, so it’s important to use it thoughtfully 
                            to ensure smooth and uninterrupted operation of your WhatsApp account.
                        </p>

                        <ul className="guidelines-list">
                            <li>
                                <strong>✅ Send responsibly:</strong> Send a maximum of{" "}
                                <b>1 text message per minute</b>.
                            </li>
                            <li>
                                <strong>📸 Media messages:</strong> Wait <b>3–5 minutes</b>{" "}
                                between sending images, videos, or documents.
                            </li>
                            <li>
                                <strong>🚫 Don’t spam:</strong> Avoid bulk or identical messages
                                rapidly — this can trigger WhatsApp’s spam detection.
                            </li>
                            <li>
                                <strong>🔗 Don’t send links in the first message:</strong> 
                                Start conversations naturally. Sending links too early can 
                                make messages appear suspicious to WhatsApp’s filters.
                            </li>
                            <li>
                                <strong>🌀 Use Spintext:</strong> Add{" "}
                                <b>text variations</b> like{" "}
                                <code>{`{Hi|Hey|Hello}`}</code> to make messages unique.
                            </li>
                            <li>
                                <strong>💬 Personalize your content:</strong> Include names or
                                dynamic data to make messages more natural.
                            </li>
                            <li>
                                <strong>🤝 Stay human:</strong> Occasionally chat directly on
                                your phone to simulate genuine behavior.
                            </li>
                            <li>
                                <strong>🔄 If disconnected:</strong>
                                <ul>
                                    <li>Go to the <b>Devices</b> tab</li>
                                    <li>Delete the old connection</li>
                                    <li>Reconnect by scanning a new QR code</li>
                                </ul>
                            </li>
                            <li>
                                <strong>⚙️ Keep WhatsApp active:</strong> Ensure your phone has
                                internet access and WhatsApp remains open in the background.
                            </li>
                        </ul>

                        <div className="guidelines-footer">
                            <CiWarning className="security-icon" />
                            <span>
                                Misuse may lead to your WhatsApp account being temporarily or
                                permanently banned.
                            </span>
                        </div>
                    </main>

                    <footer className="guidelines-actions">
                        <button className="guidelines-btn" onClick={onClose}>
                            I Understand
                        </button>
                    </footer>
                </div>
            </div>
        </Fragment>
    );
};

export default UsageGuidelinesModal;
